export const DRIVE_MATCH_KEYS = ["lifecycle", "sale_path", "cancel_reason"] as const;
export type DriveMatchKey = (typeof DRIVE_MATCH_KEYS)[number];

export type DriveFolderNode = {
  id: string;
  name: string;
  matchKey: DriveMatchKey | null;
  matchValue: string | null;
  children: DriveFolderNode[];
};

export type DriveFolderRecipe = {
  version: 1;
  nodes: DriveFolderNode[];
};

export type DriveDealFacts = {
  lifecycle: "pending" | "cancelled" | "delivered";
  sale_path: "rto" | "finance" | "cash" | "other" | "";
  cancel_reason: "rto_rejected" | "customer_cancelled" | "";
};

export const DRIVE_MATCH_OPTIONS: Array<{ key: DriveMatchKey; value: string; label: string }> = [
  { key: "lifecycle", value: "pending", label: "Pending" },
  { key: "lifecycle", value: "cancelled", label: "Cancelled" },
  { key: "lifecycle", value: "delivered", label: "Delivered" },
  { key: "sale_path", value: "rto", label: "RTO" },
  { key: "sale_path", value: "finance", label: "Finance" },
  { key: "sale_path", value: "cash", label: "Cash" },
  { key: "cancel_reason", value: "rto_rejected", label: "RTO Rejected" },
  { key: "cancel_reason", value: "customer_cancelled", label: "Customer Cancelled" },
];

export function newDriveFolderNodeId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `n-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function makeDriveFolderNode(
  name: string,
  match: { key: DriveMatchKey; value: string } | null,
  children: DriveFolderNode[] = []
): DriveFolderNode {
  return {
    id: newDriveFolderNodeId(),
    name,
    matchKey: match?.key ?? null,
    matchValue: match?.value ?? null,
    children,
  };
}

export function inferDriveFolderMatch(name: string): { key: DriveMatchKey; value: string } | null {
  const n = name.trim().toLowerCase().replace(/[_-]+/g, " ");
  if (!n || n.includes("{")) return null;
  const hit = DRIVE_MATCH_OPTIONS.find((o) => o.label.toLowerCase() === n);
  return hit ? { key: hit.key, value: hit.value } : null;
}

export function normalizeTokenFolderName(name: string): string {
  const t = name.trim();
  if (/^year$/i.test(t)) return "{year}";
  if (/^month$/i.test(t)) return "{month}";
  return t;
}
